import { render, staticRenderFns } from "./Dsweet.vue?vue&type=template&id=4e5ec07a&scoped=true&"
import script from "./Dsweet.vue?vue&type=script&lang=js&"
export * from "./Dsweet.vue?vue&type=script&lang=js&"
import style0 from "./Dsweet.vue?vue&type=style&index=0&id=4e5ec07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ec07a",
  null
  
)

export default component.exports